function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#6c5cff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d379e2"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Invitations_Creative",
  "data-name": "Invitations Creative",
  d: "M101.746,30.4V0H20.254V30.4L0,45.5v62.2A14.313,14.313,0,0,0,14.3,122H107.7A14.313,14.313,0,0,0,122,107.7V45.5Zm7.1,17.188-7.1,5.284V42.288ZM92.215,9.531V59.96L61,83.178,29.785,59.96V9.531ZM20.254,52.87l-7.1-5.284,7.1-5.3Zm87.449,59.6H14.3A4.771,4.771,0,0,1,9.531,107.7V56.774L61,95.057l51.469-38.283V107.7A4.771,4.771,0,0,1,107.7,112.469ZM54.8,34.074H45.273A15.4,15.4,0,0,1,50.4,22.621a15.985,15.985,0,0,1,12.414-3.936A15.673,15.673,0,0,1,76.639,32.391c.724,6.535-3.091,11.177-6.025,14.1-.736.733-1.412,1.374-2.009,1.938-2.746,2.6-2.839,2.842-2.839,4.263V52.9H56.235v-.206c0-5.68,2.826-8.355,5.819-11.186.582-.551,1.184-1.12,1.831-1.765,2.511-2.5,3.492-4.387,3.28-6.3a6.078,6.078,0,0,0-5.392-5.282,6.357,6.357,0,0,0-5.011,1.561A5.781,5.781,0,0,0,54.8,34.074Zm1.43,26.211h9.531v9.531H56.234Z",
  opacity: 0.75,
  fill: "url(#linear-gradient)"
});

var SvgNoInvitations = function SvgNoInvitations(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoInvitations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noInvitations.e3f51773.svg";
export { ForwardRef as ReactComponent };